import { render, staticRenderFns } from "./labelInfo.vue?vue&type=template&id=b662a79e&scoped=true&"
import script from "./labelInfo.vue?vue&type=script&lang=js&"
export * from "./labelInfo.vue?vue&type=script&lang=js&"
import style0 from "./labelInfo.vue?vue&type=style&index=0&id=b662a79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662a79e",
  null
  
)

export default component.exports